<script>
import { Input } from 'ant-design-vue'
export default {
  props: ['value', 'id', 'url'],
  data() {
    return {
      lnglat: '',
    }
  },
  mounted() {
    // eslint-disable-next-line no-undef
    this.map = new AMap.Map(this.$refs.map, {
      resizeEnable: true,
      zoom: 17,
      center: [121.398582, 29.819762],
      viewMode: '3D',
    })
    if (this.url) {
      const layer = new AMap.ImageLayer({
        url: this.url,
        bounds: [
          // 121.57602694317671,29.0239,
          // 122.075,29.6431,
          // 121.571979,28.853303,
          // 122.279016,29.655454
          121.392589, 29.816277, 121.403554, 29.82672,
        ],

        //     url: '/maptile.png',
        // bounds: new AMap.Bounds([121.56, 29.7], [122.13, 28.99]),
        // zooms: [15, 20],
      })
      this.map.add(layer)
    }
    let that = this
    // eslint-disable-next-line no-undef
    this.clickListener = this.map.on('click', function (e) {
      that.addMarker(e.lnglat)
    })
    // eslint-disable-next-line no-undef
    let autoCompleteComponent = new AMap.Autocomplete({
      input: 'tipinput',
      // outPutDirAuto: true
    })
    // eslint-disable-next-line no-undef
    AMap.event.addListener(autoCompleteComponent, 'select', (data) => {
      that.addMarker(data.poi.location)
    })
    if (this.id) {
      let lnlaObj = this.value.find((item) => item.id == this.id)
      if (lnlaObj) {
        this.map.setCenter([lnlaObj.lng, lnlaObj.lat])
      }
    }

    this.addTitle()
  },
  methods: {
    addTitle(newValue) {
      let marksValue = newValue ? newValue : this.value
      const markerList = marksValue.map(
        (item) =>
          // eslint-disable-next-line no-undef
          new AMap.Marker({
            position: [item.lng, item.lat],
            icon: item.icon || 'https://webapi.amap.com/theme/v1.3/markers/n/mark_bs.png',
          })
      )
      this.map.add(markerList)
    },
    addMarker(lnglat) {
      debugger
      this.lnglat = {
        ...lnglat,
        id: this.id || Date.now(),
      }
      this.map.clearMap()
      if (this.id) {
        let index = this.value.findIndex((e) => e.id == this.id)
        let newValue = [...this.value]
        newValue.splice(index, 1)
        this.$nextTick(() => {
          this.addTitle(newValue)
        })
      } else {
        this.addTitle()
      }
      this.map.setCenter([lnglat.lng, lnglat.lat])
      let icon = new AMap.Icon({
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
        imageSize: new AMap.Size(20, 40),
      })
      this.map.add(
        // eslint-disable-next-line no-undef
        new AMap.Marker({
          position: [lnglat.lng, lnglat.lat],
          icon,
        })
      )
    },
    getData() {
      return this.lnglat
    },
  },
  render() {
    return (
      <div class="mapview-main">
        <div ref="map" style={{ display: 'flex', height: '300px' }} />
      </div>
    )
  },
}
</script>
<style lang="less" scoped>
.mapview-main {
  display: flex;
  flex-direction: column;
  & > div {
    margin-top: 20px;
  }
}
</style>
